import { AnalysisUseCase, AnalysisViewFragment } from 'generated/graphql';
import { DashboardFeedHeaderSubtitle } from './DashboardFeedHeaderSubtitle';
import { DashboardQuantifyHeaderSubtitle } from './DashboardQuantifyHeaderSubtitle';

interface DashboardAnalysisSubtitleProps {
  analysis: AnalysisViewFragment;
}

export const DashboardAnalysisSubtitle = ({
  analysis,
}: DashboardAnalysisSubtitleProps) => {
  if (analysis.useCase === AnalysisUseCase.Feed) {
    return <DashboardFeedHeaderSubtitle analysis={analysis} />;
  }

  return <DashboardQuantifyHeaderSubtitle />;
};
